import { render, staticRenderFns } from "./DuplicateItems.vue?vue&type=template&id=c58d3a04&"
import script from "./DuplicateItems.vue?vue&type=script&lang=js&"
export * from "./DuplicateItems.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateItems.vue?vue&type=style&index=0&id=c58d3a04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports